module.exports = __webpack_public_path__ + "static/img/学生.da67059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/学生.png
// module id = i+xO
// module chunks = 1